import * as THREE from "three";
import * as ThreeMeshUI from "three-mesh-ui";

/**
 * Various content types that can be switched between.
 */
export type HelperUIType = "NoFloorPlane" | "NoOffset" | 'None' | "PlacementConfirmed";

/**
 * HelperUI is a three group with text elements intended to be attached to the HMD.
 */
export class ContentUI extends THREE.Group {
  // helperContents = new THREE.Group()
  helperContents = {
    NoFloorPlane: new THREE.Group(),
    NoOffset: new THREE.Group(),
    PlacementConfirmed: new THREE.Group(),
  };

  private _fontPath = "./Roboto-msdf.json";
  private _fontTexturePath = "./Roboto-msdf.png";

  private _content: HelperUIType = 'None';

  get content(): HelperUIType {
    return this._content;
  }


  constructor() {
    super();
    this.renderOrder = 2000;
    // this.add(new LollipopHelper());
    // This is typically done in the render loop :
    this.createContents();
    ThreeMeshUI.update();
  }

  createContents() {

    
    Object.entries(this.helperContents).forEach(([key, value]) => {
        this.add(value);
      });

    this.helperContents["NoFloorPlane"].add(this.createTextContent("No floor plane detected"));
    this.helperContents["NoOffset"].add(this.createTextContent("Engine not placed. \nPoint your hand at the floor and pinch to place the engine."));
    this.helperContents["PlacementConfirmed"].add(this.createTextContent("Engine placed. \nYou can now interact with the engine."));


  }


  createTextContent(content: string) {
    const container = new ThreeMeshUI.Block({
      width: 1.2,
      height: 2.7,
      padding: 0.2,
      fontFamily: this._fontPath,
      fontTexture: this._fontTexturePath,
      opacity: 1,
    });
    // @ts-ignore This is actually a valid property
    container.borderRadius = 0.05;
    const text = new ThreeMeshUI.Text({
      content: content,
      opacity: 1,
    });
    container.add(text);

    return container;
    // this.helperContents["NoFloorPlane"].add(container);

  }



  setContent(content: HelperUIType) {
    Object.entries(this.helperContents).forEach(([key, value]) => {
      value.visible = false;
    });
    this._content = content;
    if (content === 'None') {
      return;
    }
    try {
      this.helperContents[content].visible = true;
    } catch (error) {
      console.error("Error setting content:", content, error);
    }
  }


  update() {
    ThreeMeshUI.update();
  }

}
